import Transform from "@ember-data/serializer/transform";
import TimedTransaction from "cnam/models/timed-transaction";
export default class TimedTransactionTransform extends Transform {
  deserialize(serialized) {
    return serialized?.map(item => new TimedTransaction(item["name"], item["start_date"], item["end_date"], item["success"], item["error"])) || [];
  }
  serialize(deserialized) {
    return deserialized?.map(item => {
      return {
        name: item.name,
        start_date: item.startDate,
        end_date: item.endDate,
        success: item.success,
        error: item.error
      };
    }) || [];
  }
}